import { AccountingJournal, DNPrefixStructure } from '@accounting/interfaces/accounting-journal';
import moment from 'moment';

export class DocumentNumberHelper {
  public static yearlyStructureOptions = [
    DNPrefixStructure.YEAR_2_DIGITS,
    DNPrefixStructure.YEAR_4_DIGITS,
  ];

  public static monthlyStructureOptions = [
    DNPrefixStructure.MONTH_2_DIGITS,
    DNPrefixStructure.YEAR_2_DIGITS_AND_MONTH_2_DIGITS,
    DNPrefixStructure.YEAR_4_DIGITS_AND_MONTH_2_DIGITS,
  ];

  public static getFullPrefix(accountingJournal: AccountingJournal, date?: string): string {
    date = date ? date : moment().format('YYYY-MM-DD');
    const ajCode = accountingJournal.code || '';
    const prefix = DocumentNumberHelper.getPrefix(
      accountingJournal.document_number_prefix_structure,
      date,
    );
    return `${ajCode}${prefix}`;
  }

  public static getFullPrefixAndZeros(
    sequence: number,
    accountingJournal: AccountingJournal,
    date?: string,
  ): string {
    date = date ? date : moment().format('YYYY-MM-DD');
    const prefix = DocumentNumberHelper.getFullPrefix(accountingJournal, date);
    const documentNumberLength = accountingJournal.invoice_code_length || 5;

    const sequenceLength = sequence.toString().length;
    const zeroString = ''.padEnd(documentNumberLength - sequenceLength, '0');
    return `${prefix}${zeroString}`;
  }

  public static getDocumentNumber(
    sequence: number,
    accountingJournal: AccountingJournal,
    date?: string,
  ) {
    date = date || moment().format('YYYY-MM-DD');
    const documentNumberLength = accountingJournal.invoice_code_length || 5;
    const sequenceStr = `${sequence.toString().padStart(documentNumberLength, '0')}`;
    const fullPrefix = DocumentNumberHelper.getFullPrefix(accountingJournal, date);
    return `${fullPrefix}${sequenceStr}`;
  }

  public static getPrefix(prefixStructure: DNPrefixStructure, date?: string): string {
    const momentDate = date ? moment(date) : moment();
    switch (prefixStructure) {
      case DNPrefixStructure.YEAR_4_DIGITS:
        return momentDate.format('YYYY');
      case DNPrefixStructure.YEAR_4_DIGITS_AND_MONTH_2_DIGITS:
        return momentDate.format('YYYYMM');
      case DNPrefixStructure.YEAR_2_DIGITS:
        return momentDate.format('YY');
      case DNPrefixStructure.YEAR_2_DIGITS_AND_MONTH_2_DIGITS:
        return momentDate.format('YYMM');
      case DNPrefixStructure.MONTH_2_DIGITS:
        return momentDate.format('MM');
      // case DNPrefixStructure.NO_PREFIX:
      //   return '';
      default:
        return '';
    }
  }

  public static getPeriodUnit(prefixStructure: DNPrefixStructure): 'months' | 'years' | null {
    if (DocumentNumberHelper.yearlyStructureOptions.includes(prefixStructure)) {
      return 'years';
    }
    if (DocumentNumberHelper.monthlyStructureOptions.includes(prefixStructure)) {
      return 'months';
    }

    return null;
  }
}
